export const sortFunc = function (a, b) {
  return Number(a.sort) - Number(b.sort);
};